export default __webpack_public_path__ + "static/media/mongodb.275d22c8.png";